/**
 * @module utils/data
 */

/**
 * Generates a unique ID.
 * @returns {String}
 */
const existingUniqueIds = {};
export function uniqueId() {
  const range = Math.pow(10, 9);
  let id = null;
  while (!id || existingUniqueIds[id]) id = 'id' + ((Math.random() * range) | 0).toString(36);
  existingUniqueIds[id] = true;
  return id;
}

/**
 * Object data storage.
 */
const elementDataStorage = {
  _storage: new WeakMap(),
  put: function (element, key, obj) {
    if (!this._storage.has(element)) {
      this._storage.set(element, new Map());
    }
    this._storage.get(element).set(key, obj);
  },
  get: function (element, key) {
    return this._storage.get(element).get(key);
  },
  has: function (element, key) {
    return this._storage.has(element) && this._storage.get(element).has(key);
  },
  remove: function (element, key) {
    var ret = this._storage.get(element).delete(key);
    if (!this._storage.get(element).size === 0) {
      this._storage.delete(element);
    }
    return ret;
  }
}

/**
 * Attaches an arbitrary value reference to an element (emulates jQuery.data())
 * @param   {HTMLElement} element - The element to attach the data to.
 * @param   {String} attribute - The attribute name to store the data at.
 * @param   {*} value - The data value to store; can be any valid JS object or variable.
 * @returns {*} - The passed value, just returned back again.
 */
export function putData(element, attribute, value = {}) {
  if (!element) {
    console.warn(`Invalid element passed to utils/data/putData()`);
    return;
  }

  // Create a datastore key and add it to the element
  const dataStoreId = uniqueId();
  element.setAttribute(`data-${attribute}-dataStoreId`, dataStoreId);

  // Put it into storage
  if (!elementDataStorage.has(element, dataStoreId))
    elementDataStorage.put(element, dataStoreId, value);
  return value;
}

/**
 * Returns the value from the passed element and attribute
 * @param   {HTMLElement} element - The element to get the data from.
 * @param   {String} attribute - The attribute to get the data from.
 * @returns {*} - The found value.
 */
export function getData(element, attribute) {
  if (!element) {
    console.warn(`Invalid element passed to utils/data/getData()`);
    return;
  }

   // Get the storage key
   const dataAttribute = `data-${attribute}-dataStoreId`,
     dataStoreId = element.hasAttribute(dataAttribute) ? element.getAttribute(dataAttribute) : false;
   if (!dataStoreId) {
     console.warn(`Data store key: "${dataAttribute}" does not exist`);
     return;
   }

  // Get the value from storage
  if (!elementDataStorage.has(element, dataStoreId)) {
    console.warn(`Unable to get data from element attribute "${dataAttribute}"`);
    return false;
  } else {
    return elementDataStorage.get(element, dataStoreId);
  }
}



// WEBPACK FOOTER //
// ./source/scripts/utils/data.js